import Phaser from 'phaser';
// import 'phaser/plugins/spine/dist/SpinePlugin';
import 'phaser/plugins/spine4.1/dist/SpinePlugin';

export default {
    type: Phaser.AUTO,
    width: 720,
    height: 1280,
    parent: '',
    scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    plugins: {
        scene: [{ key: 'SpinePlugin', plugin: window.SpinePlugin, mapping: 'spine' }],
    },
    prefix: 'tap_story_',
    soundMaxVolume: 1,
    musicMaxVolume: 0.5,
    responsive: true,
    lockOrientation: 'portrait', // false, portrait, landscape
};
